import './TabPanel.css';
export var tabPanelCSS = '_b4irt10-3-5-0';
export var tabPanelOverflowBehaviorCSS = {hidden:'_b4irt11-3-5-0','scroll-y':'_b4irt12-3-5-0'};